import React from 'react'
import ReactDOM from 'react-dom'
import App from './Containers/App/App'
import './index.css'
import { loadFonts } from './Helpers'

// Start render.
ReactDOM.render(
  <App />,
  document.getElementById('root')
)

// Start loading fonts.
loadFonts()



// WEBPACK FOOTER //
// ./src/index.js